// Promisified version of setTimeout so you can easily await return values
const setTimeoutPromise = <T>(cb: () => T | PromiseLike<T>, timeout: number) =>
  new Promise<T>((resolve) => setTimeout(() => resolve(cb()), timeout));

export default setTimeoutPromise;
